export const BRAND = "Smart Telecom Advisor";
export const PHONE_DISPLAY = "+32 473 22 33 44";
export const PHONE_TEL = "tel:+32473223344";
export const WHATSAPP_URL = "https://wa.me/32473223344";
export const GOOGLE_BUSINESS_URL = "https://www.google.com/search?q=Smart+Telecom+Advisor";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CcHHs34jZIZDEBM/review";
export const CONTACT_EMAIL = "sam@smartelecomadvisor.be";
